import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { ComplianceRing } from "@/components/Compliance";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import { Loader2, CheckCircle2, Clock, AlertTriangle, ListChecks } from "lucide-react";

const STATS = [
  { key: "total", label: "Total", icon: ListChecks, color: "text-slate-700", bg: "bg-slate-100" },
  { key: "completada", label: "Completadas", icon: CheckCircle2, color: "text-emerald-600", bg: "bg-emerald-50" },
  { key: "pendiente", label: "Pendientes", icon: Clock, color: "text-yellow-600", bg: "bg-yellow-50" },
  { key: "vencida", label: "Vencidas", icon: AlertTriangle, color: "text-red-600", bg: "bg-red-50" },
];

export default function MyCompliance() {
  const [period, setPeriod] = useState("mes");
  const { data, isLoading } = useQuery({
    queryKey: ["my-compliance", period],
    queryFn: () => api.get(`/compliance/me?period=${period}`).then((r) => r.data),
  });

  if (isLoading || !data) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;

  return (
    <div className="space-y-6" data-testid="my-compliance-page">
      <div>
        <h1 className="font-heading text-2xl font-extrabold tracking-tight text-slate-900">Mi cumplimiento</h1>
        <p className="text-sm text-slate-500">Tu desempeño en el período</p>
      </div>

      <Tabs value={period} onValueChange={setPeriod}>
        <TabsList data-testid="my-period-tabs">
          <TabsTrigger value="hoy">Hoy</TabsTrigger>
          <TabsTrigger value="semana">Semana</TabsTrigger>
          <TabsTrigger value="mes">Mes</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="flex flex-col items-center rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <ComplianceRing pct={data.compliance} size={150} />
        <p className="mt-4 text-sm text-slate-500">{data.completada} de {data.total} tareas completadas</p>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {STATS.map((s) => (
          <div key={s.key} className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-testid={`mystat-${s.key}`}>
            <div className={cn("mb-2 inline-flex h-9 w-9 items-center justify-center rounded-lg", s.bg)}>
              <s.icon className={cn("h-5 w-5", s.color)} />
            </div>
            <div className="font-heading text-2xl font-extrabold text-slate-900">{data[s.key]}</div>
            <div className="text-xs font-medium text-slate-500">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
